var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame42744(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame 42744"
  }, /*#__PURE__*/React.createElement("g", {
    id: "account_circle"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_147_10131",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 9,
    width: 37,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 11.7861,
    y: 9.35596,
    width: 35.5381,
    height: 35.5381,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_147_10131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "account_circle_2",
    d: "M20.4489 34.6768C21.7076 33.7143 23.1143 32.9551 24.6691 32.3994C26.2239 31.8446 27.8527 31.5672 29.5556 31.5672C31.2584 31.5672 32.8873 31.8446 34.4421 32.3994C35.9969 32.9551 37.4036 33.7143 38.6622 34.6768C39.526 33.6649 40.1987 32.5173 40.6805 31.234C41.1612 29.9507 41.4016 28.581 41.4016 27.1249C41.4016 23.8426 40.2481 21.0474 37.9411 18.7394C35.6331 16.4324 32.8379 15.2789 29.5556 15.2789C26.2732 15.2789 23.4786 16.4324 21.1716 18.7394C18.8636 21.0474 17.7096 23.8426 17.7096 27.1249C17.7096 28.581 17.9504 29.9507 18.4322 31.234C18.9129 32.5173 19.5852 33.6649 20.4489 34.6768ZM29.5556 28.6057C28.0995 28.6057 26.8715 28.1062 25.8715 27.1072C24.8725 26.1071 24.3729 24.8791 24.3729 23.423C24.3729 21.967 24.8725 20.7389 25.8715 19.7389C26.8715 18.7399 28.0995 18.2404 29.5556 18.2404C31.0117 18.2404 32.2397 18.7399 33.2397 19.7389C34.2387 20.7389 34.7382 21.967 34.7382 23.423C34.7382 24.8791 34.2387 26.1071 33.2397 27.1072C32.2397 28.1062 31.0117 28.6057 29.5556 28.6057ZM29.5556 41.9325C27.5072 41.9325 25.5822 41.5435 23.7806 40.7656C21.9791 39.9887 20.4119 38.9339 19.0793 37.6013C17.7466 36.2686 16.6918 34.7014 15.9149 32.8999C15.137 31.0983 14.748 29.1733 14.748 27.1249C14.748 25.0765 15.137 23.1516 15.9149 21.35C16.6918 19.5484 17.7466 17.9813 19.0793 16.6486C20.4119 15.3159 21.9791 14.2606 23.7806 13.4827C25.5822 12.7058 27.5072 12.3174 29.5556 12.3174C31.604 12.3174 33.5289 12.7058 35.3305 13.4827C37.1321 14.2606 38.6992 15.3159 40.0319 16.6486C41.3646 17.9813 42.4194 19.5484 43.1963 21.35C43.9742 23.1516 44.3631 25.0765 44.3631 27.1249C44.3631 29.1733 43.9742 31.0983 43.1963 32.8999C42.4194 34.7014 41.3646 36.2686 40.0319 37.6013C38.6992 38.9339 37.1321 39.9887 35.3305 40.7656C33.5289 41.5435 31.604 41.9325 29.5556 41.9325Z",
    fill: "#B5B8C5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame42744);
export default __webpack_public_path__ + "static/media/Frame 42744.d2418ba95d61e65af34b0ef62ba04498.svg";
export { ForwardRef as ReactComponent };